import React, { useEffect, useState } from 'react'
import './AddBudgetForm.css'
import { Form } from 'react-bootstrap';
import { get_budget_list, update_budget_status, getActivity, getSubActivity } from '../../../helper/Api';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApprovalBudgetPreview from '../../Modal/ApprovalBudgetPreview';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from "@mui/material";

const ViewBudgetForm = () => {
    const { id } = useParams();
    const { authData, financialYears } = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const [showPreview, setShowPreview] = useState(false);
    const [budgetStatus, setBudgetStatus] = useState(false);
    const [activity, setActivity] = useState([]);
    const [subActivity, setSubActivity] = useState([]);
    const [formData, setFormData] = useState({
        "id": "",
        "l3remarks": "",
        "l2remarks": "",
        "subhead_id": "",
        "scheme_id": "",
        "financial_year": "",
        "budget": "",
        "budget_order_no": "",
        "budget_order_date": "",
        "budget_date": "",
        "l2_status": "",
        "l3_status": "",
        "added_on": "",
        "added_by": "",
        "subhead_code": "",
        "subhead_name": "",
        "scheme_code": "",
        "scheme_name": "",
        "attachments": [],
        "activities": [],
    });

    const navigate = useNavigate();

    useEffect(() => {
        fetchActivity();
        fetchSubActivity();
        get_budget_details();
    }, [id])

    const get_budget_details = async () => {
        const { data } = await get_budget_list(null, id);
        if (data.status) {
            setFormData(data.budgets[0]);
        } else {
            setFormData([]);
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
    }

    const update_budget_status_by_id = async () => {
        if (formData.id && budgetStatus) {
            let post_data = {};
            if (authData.user.user_type === 'l3') {
                post_data = {
                    "l3_status": budgetStatus,
                    "budget_id": formData.id,
                    "l3remarks": formData.l3remarks
                };
            } else if (authData.user.user_type === 'l2') {
                post_data = {
                    "l2_status": budgetStatus,
                    "budget_id": formData.id,
                    "l2remarks": formData.l2remarks
                };
            }
            const { data } = await update_budget_status(post_data);
            if (data.status) {
                toast.success(data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
                setShowPreview(false);
                navigate('/budgets');
            } else {
                toast.error(data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        }
    }

    const previewhandler = (type) => {
        setShowPreview(true);
        setBudgetStatus(type);
    };

    const handleInvoiceChange = (e) => {
        let { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const fetchActivity = async () => {
        try {
            const resp = await getActivity();
            if (resp.data.status) {
                setActivity(resp.data.result);
            }
        } catch (error) {
            setActivity([]);
        }
    }
    const fetchSubActivity = async () => {
        try {
            const resp = await getSubActivity();
            if (resp.data.status) {
                setSubActivity(resp.data.result);
            }
        } catch (error) {
            setSubActivity([]);
        }
    }
    const findSubActivitiesById = (id) => {
        let listData = subActivity;
        return listData.filter(subActivity => subActivity.activity_id === id);
    };
    const linksArray = [
        {
        href: "/budgets",
        label: "Budgets",
        },
    ];
    return (
        <div>
            <ApprovalBudgetPreview showPreview={showPreview} setShowPreview={setShowPreview} financialYear={fy_list} formData={formData} handleSubmit={update_budget_status_by_id}></ApprovalBudgetPreview>
            <div className="p-3">
                <div className="row" style={{padding: '10px 16px'}}>
                    <div className="col-md-6">
                    <h4> View Budget</h4>
                    <CustomBreadcrumbs linksArray={linksArray} title="View Budget" />
                    </div>
                    <div className="col-md-6">
                    <div
                        className="d-flex gap-2"
                        style={{ width: "auto", float: "right" }}
                    >
                        {
                            authData.user.user_type === 'l2' ?
                                <>
                                    {formData.l2_status == 0 ? (<>
                                        <button type="button" className="reject_button" onClick={() => previewhandler(2)}>Reject</button>&nbsp;
                                        <button type="button" className="submit_button" onClick={() => previewhandler(1)}>Approve</button>
                                    </>) : formData.l2_status == 1 ? (<>
                                        <button type="button" className="submit_button">Already Approved</button>
                                    </>) : (<>
                                        <button type="button" className="reject_button" >Already Rejected</button>
                                    </>)}
                                </> : authData.user.user_type === 'l3' ? (
                                    <>
                                        {formData.l3_status === "0" ? (<>
                                            <button type="button" className="reject_button" onClick={() => previewhandler(2)}>Reject</button>&nbsp;
                                            <button type="button" className="submit_button" onClick={() => previewhandler(1)}>Approve</button>
                                        </>) : formData.l3_status === "1" ? (<>
                                            <button type="button" className="submit_button">Already Approved</button>
                                        </>) : (<>
                                            <button type="button" className="reject_button" >Already Rejected</button>
                                        </>)}
                                    </>
                                ) : (
                                    ""
                                )
                        }
                    </div>
                    </div>
                </div>
                <div className="row">
                    <Form onSubmit={handleSubmit}>
                        <div className="col-md-12">
                            <div className="card" style={{padding: '0px 12px', borderRadius: "0px"}}>
                                <div className="row">
                                    <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden">
                                        <span
                                            className="fs-14px white-space-nowrap overflow-x-hidden"
                                            style={{ width: "95%", fontStyle: "italic" }}
                                        >
                                            <span
                                            className="fs-14px white-space-nowrap overflow-x-hidden "
                                            style={{ width: "95%" }}
                                            >
                                            <span
                                                className="fw-600 fs-16px"
                                                style={{ fontStyle: "normal" }}
                                            >
                                                General
                                            </span>
                                            </span>
                                        </span>
                                    </div>

                                    <div className="col-sm-12 p-2">
                                        <FormControl fullWidth>
                                            <InputLabel id="financial_year_label">Financial Year *</InputLabel>
                                            <Select
                                                labelId="financial_year_label"
                                                id="financial_year_id"
                                                value={formData.financial_year || ""}
                                                label="Financial Year *"
                                                readOnly
                                            >
                                                {fy_list.map((fy) => (
                                                    <MenuItem value={fy.id} key={fy.id}>
                                                        {fy.year}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>

                                    <div className="col-sm-12 p-2">
                                        <FormControl fullWidth>
                                            <TextField
                                                label="Scheme Name"
                                                variant="outlined"
                                                type="text"
                                                value={formData.scheme_name || ""}
                                                required
                                                readOnly
                                            />
                                        </FormControl>
                                    </div>
                
                                    <div className="col-sm-6 p-2">
                                        <FormControl fullWidth>
                                            <TextField
                                                id="budget_order_no"
                                                label="Budget Order No"
                                                variant="outlined"
                                                type="text"
                                                name="budget_order_no"
                                                value={formData.budget_order_no || ""}
                                                required
                                                readOnly
                                            />
                                        </FormControl>
                                    </div>
                                    <div className="col-sm-6 p-2">
                                        <FormControl fullWidth>
                                            <TextField
                                                type="date"
                                                id="budget_order_date"
                                                label="Budget Order Date"
                                                name="budget_order_date"
                                                value={formData.budget_order_date}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                readOnly
                                            />
                                        </FormControl>
                                    </div>

                                    <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden">
                                        <span
                                            className="fs-14px white-space-nowrap overflow-x-hidden"
                                            style={{ width: "95%", fontStyle: "italic" }}
                                        >
                                            <span
                                            className="fs-14px white-space-nowrap overflow-x-hidden "
                                            style={{ width: "95%" }}
                                            >
                                            <span
                                                className="fw-600 fs-16px"
                                                style={{ fontStyle: "normal" }}
                                            >
                                                Subhead
                                            </span>
                                            </span>
                                        </span>
                                    </div>

                                    <div className="col-sm-6 p-2">
                                        <FormControl fullWidth>
                                            <TextField
                                                id="subhead_code"
                                                label="Subhead Code"
                                                variant="outlined"
                                                type="text"
                                                value={formData.subhead_code || ""}
                                                InputLabelProps={{ shrink: true }}
                                                readOnly
                                            />
                                        </FormControl>
                                    </div>
                                    <div className="col-sm-6 p-2">
                                        <FormControl fullWidth>
                                            <TextField
                                                id="subhead_name"
                                                label="Subhead Name"
                                                variant="outlined"
                                                type="text"
                                                value={formData.subhead_name || ""}
                                                InputLabelProps={{ shrink: true }}
                                                readOnly
                                            />
                                        </FormControl>
                                    </div>

                                    <div className="col-sm-6 p-2">
                                        <FormControl fullWidth>
                                            <TextField
                                                type="date"
                                                id="budget_date"
                                                label="Budget Date"
                                                name="budget_date"
                                                value={formData.budget_date}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                readOnly
                                            />
                                        </FormControl>
                                    </div>
                                    <div className="col-sm-6 p-2"></div>

                                    <div className="col-sm-6 p-2">
                                        <FormControl fullWidth>
                                            <TextField
                                                type="number"
                                                id="provisional_budget"
                                                label="Provisional Budget"
                                                name="provisional_budget"
                                                value={formData.subhead_provisional_budget || 0}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                readOnly
                                            />
                                        </FormControl>
                                    </div>
                                    <div className="col-sm-6 p-2">
                                        <FormControl fullWidth>
                                            <TextField
                                                type="number"
                                                id="budget"
                                                label="Released Budget"
                                                name="budget"
                                                value={formData.budget || 0}
                                                InputLabelProps={{ shrink: true }}
                                                required
                                                readOnly
                                            />
                                        </FormControl>
                                    </div>


                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-sm-6 p-2">
                                                <FormControl fullWidth>
                                                    <TextField
                                                        type="text"
                                                        id="l2remarks"
                                                        label="L2 Remarks"
                                                        name="l2remarks"
                                                        value={formData.l2remarks || ""}
                                                        InputLabelProps={{ shrink: true }}
                                                        onChange={(e) => handleInvoiceChange(e)}
                                                        disabled={authData.user.user_type !== 'l2'}
                                                    />
                                                </FormControl>
                                            </div>
                                            <div className="col-sm-6 p-2">
                                                <FormControl fullWidth>
                                                    <TextField
                                                        type="text"
                                                        id="l3remarks"
                                                        label="L3 Remarks"
                                                        name="l3remarks"
                                                        value={formData.l3remarks || ""}
                                                        InputLabelProps={{ shrink: true }}
                                                        onChange={(e) => handleInvoiceChange(e)}
                                                        disabled={authData.user.user_type !== 'l3'}
                                                    />
                                                </FormControl>
                                            </div>
                                            <div className="col-sm-12 p-2">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="input-group">
                                                            <label className="input-group-btn my-0">
                                                                Upload Budget Document
                                                            </label>
                                                            {
                                                                formData.attachments.map((att, i) => {
                                                                    return (<a href={att.file_url} target='_blank'>&nbsp;Attachment {i + 1}</a>);
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {formData.activities && formData.activities.length != 0 && <div className="row">
                                    <table className="table table-bordered">
                                        <thead className="text-center-custom">
                                            <tr>
                                                <th scope="col" width="150px">Activity</th>
                                                <th scope="col" width="150px">Subactivity</th>
                                                <th scope="col" width="300px">Opening Provision</th>
                                                <th scope="col" width="300px">Opening Release</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-center-custom">
                                            {formData.activities.map((activityData, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name='activity_id'
                                                            value={activityData.subhead_activity_id} disabled={true}>
                                                            <option value="">---Select---</option>
                                                            {activity.map(e => (
                                                                <option key={e.id} value={e.id}>{e.activity}</option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            name='subactivity_id'
                                                            value={activityData.subhead_subactivity_id}
                                                            disabled={true}>
                                                            <option value="">---Select---</option>
                                                            {findSubActivitiesById(activityData.subhead_activity_id).map(e => (
                                                                <option key={e.id} value={e.id}>{e.subactivity}</option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="provisional_budget"
                                                            value={activityData.provisional_budget || ''}
                                                            disabled={true}

                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="budget"
                                                            value={activityData.budget || ''}
                                                            disabled={true}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default ViewBudgetForm
